import { forwardRef, HTMLProps, useId } from 'react';
import { useFormContext } from 'react-hook-form';

interface Props
  extends Omit<HTMLProps<HTMLInputElement>, 'type' | 'className'> {
  label?: string;
  name: string;
  uncontrol?: boolean;
  defaultChecked?: boolean;
}

const Radio = forwardRef<HTMLInputElement, Props>(
  (
    {
      label: lable,
      children,
      uncontrol = false,
      defaultChecked = false,
      ...rest
    }: Props,
    ref
  ) => {
    let id = useId();
    if (rest.id) {
      id = rest.id;
    }
    const methods = useFormContext();

    return (
      <div className="flex items-center pl-3">
        <input
          id={id}
          type="radio"
          className="w-4 h-4 bg-grey-100 border-grey-300 text-primary-600 focus:ring-primary-500 dark:focus:ring-primary-600"
          defaultChecked={!!defaultChecked}
          {...(!uncontrol && methods.register(rest.name))}
          {...rest}
          ref={ref}
        />
        <label
          htmlFor={id}
          className="w-full text-sm font-medium rtl:mr-2 ltr:ml-2 text-grey-900 dark:text-grey-300"
        >
          {children || lable}
        </label>
      </div>
    );
  }
);

Radio.displayName = 'Radio';

export default Radio;
